export const getTokenExpiredFromStorage = (): boolean | null => {
  const tokenExpired = localStorage.getItem('tokenExpired');

  if (tokenExpired) {
    return JSON.parse(tokenExpired);
  }

  return null;
};
